module.exports = __webpack_public_path__ + "img/spacing-height-02.5cdf6e14.svg";